import "./index.less"
import { getGoodsWishList, updateGoodsWishList } from '../../utils/fetch'
import { gaProductDetailDataLayer, } from "@utils/index.js"

export default () => {
    if (!customElements.get('jky-wishlist')) {
        customElements.define('jky-wishlist', class JkyWishlist extends HTMLElement {
            constructor() {
                super();
                this.LOCAL_STORAGE_WISHLIST_KEY = "_jky_wishlist"
                this.select_id = Number(this.getAttribute("variant-id"))
                this.select_variant_title = this.getAttribute('variant-title')
                this.goodsid = Number(this.getAttribute("goodsid"))
                this.wishListInfo = null
                this.selected = false // 当前变体使用已添加心愿单
                this.variantwrap = document.querySelector(".variant-input-wrap")
                this.shortname = this.getAttribute("shortname") || ""
                this.selectors = {
                    heart: this.querySelector("#heart"),
                    content: this.querySelector(".app-wishlist-content"),
                    tips: this.querySelector(".app-wishlist-tips"),
                    tooltip: this.querySelector(".app-wishlist-tooltip"),
                    container: this.querySelector(".app-wishlist-container")
                }

                // main-product 触发variant变化 - 改变当前变体
                if (this.variantwrap) { // 就main-product
                    let this_ = this;
                    $(this.variantwrap).find("label").click(function () {
                        this_.select_id = Number($(this).attr("data-product-label"));
                        this_.select_variant_title = $(this).find('.goods-title').text()
                        this_.init()
                    })
                }

                this.selectors.container.addEventListener("click", () => {
                    this.handleAction()
                })

                this.init()
            }

            init() {
                this.addLoading()
                getGoodsWishList({
                    "goods-id": this.goodsid,
                    "skuId": this.select_id
                }).then(res => {
                    if (res.data) {
                        this.wishListInfo = res.data

                        // 渲染underBtnText - tips
                        if (this.wishListInfo.underBtnText.length) {
                            this.selectors.tips.innerHTML = this.wishListInfo.underBtnText.join('<br>')
                        }

                        // 渲染hoverText - tooltips
                        if (this.wishListInfo.hoverText.length) {
                            if (this.wishListInfo.hoverText.length === 1 && this.wishListInfo.hoverText[0] == '') {
                                $(this.selectors.tooltip).hide()
                            } else {
                                this.selectors.tooltip.querySelector(".jky-tooltip__inner").innerHTML = this.wishListInfo.hoverText.join('<br>')
                            }
                        } else {
                            $(this.selectors.tooltip).hide()
                        }

                        this.variantChange()

                        if (this.wishListInfo.login && sessionStorage.getItem(this.LOCAL_STORAGE_WISHLIST_KEY)) {
                            let _params = new URLSearchParams(window.location.search);
                            const pendding = _params.get("pendding_wish_list")
                            if (pendding) {
                                this.addToWish()
                                _params.delete("pendding_wish_list")
                                var newUrl = window.location.origin + window.location.pathname + "?" + _params.toString();
                                window.history.pushState({
                                    path: newUrl
                                }, "", newUrl);
                            } else {
                                sessionStorage.removeItem(this.LOCAL_STORAGE_WISHLIST_KEY)
                            }
                        }

                        $(this).addClass("active")
                    }
                }).finally(() => {
                    this.removeLoading()
                })
            }

            variantChange(del = false) {
                // 渲染content - unAddBtnName + wishCount
                let text = this.wishListInfo.showNum === 'YES' ? `(${this.wishListInfo.wishCount})` : ''
                this.wishListInfo.userSkuIdWishList = this.wishListInfo.userSkuIdWishList ? this.uniqeArray(this.wishListInfo.userSkuIdWishList) : []
                if (this.wishListInfo.userSkuIdWishList.indexOf(this.select_id) === -1) { // 当前变体未在用户心愿单中
                    text = this.wishListInfo.unAddBtnName + text
                    this.selected = false
                    this.selectors.heart.classList.remove("filled")
                } else {
                    text = this.wishListInfo.addedBtnName + text
                    this.selected = true
                    this.selectors.heart.classList.add("filled")
                }

                del && this.selectors.heart.classList.remove("filled")

                this.selectors.content.innerHTML = text
            }

            handleRemove() { // 移除心愿单
                ZModle.getInstance(this.renderRmovePopup(), {
                    id: "app-wishlist-popup_remove",
                    class: "app-wishlist-popup_remove",
                    cb: (el) => {
                        const leftBtn = $(el).find(".popup_remove-left")
                        leftBtn.click(() => {
                            $(el).find(".close").trigger('click');

                            // 数据埋码
                            gaProductDetailDataLayer({
                                "product_spu_name": this.getAttribute("product-title"), //识别页面产品spu标题名称text
                                "module": "Wishlist", //固定模块命名Wishlist
                                "options": this.select_variant_title, //主体产品sku文本text
                                "button_name": leftBtn?.text()?.trim(), //识别按钮的文本text
                            })
                        })

                        const rightBtn = $(el).find(".popup_remove-right")
                        rightBtn.click(() => {
                            $(el).find(".close").trigger('click');

                            this.addLoading()
                            updateGoodsWishList({
                                "shopifyGoodsId": this.goodsid,
                                "skuIds": [this.select_id],
                                "isDel": true
                            }).then(res => {
                                pushMessage(pageInfo.strings.product.wishlist_removeToast, "warning")
                                const index = this.wishListInfo.userSkuIdWishList.indexOf(this.select_id)
                                if (index !== -1) {
                                    this.wishListInfo.userSkuIdWishList.splice(index, 1)
                                }

                                this.wishListInfo.wishCount = res.data.showCount
                                this.variantChange(true)
                            }).catch(res => {
                                if (res.code == 71006) {
                                    pushMessage(pageInfo.strings.product.wishlist_disabledJoinDesc, "warning");
                                } else {
                                    pushMessage("Woops! Something wrong! Please try leater", "warning");
                                }
                            }).finally(() => {
                                this.removeLoading()

                                // 数据埋码
                                gaProductDetailDataLayer({
                                    "product_spu_name": this.getAttribute("product-title"), //识别页面产品spu标题名称text
                                    "module": "Wishlist", //固定模块命名Wishlist
                                    "options": this.select_variant_title, //主体产品sku文本text
                                    "button_name": rightBtn?.text()?.trim(), //识别按钮的文本text
                                })
                            })
                        })
                    }
                })
            }

            handleAdd() { // 添加心愿单 - 未登录情况下
                if (this.wishListInfo.login) {
                    this.addToWish(true)

                    // 数据埋码
                    gaProductDetailDataLayer({
                        "product_spu_name": this.getAttribute("product-title"), //识别页面产品spu标题名称text
                        "module": "Wishlist", //固定模块命名Wishlist
                        "options": this.select_variant_title, //主体产品sku文本text
                        "button_name": this.selectors.content.innerText, //识别按钮的文本text
                    })
                } else {
                    ZModle.getInstance(this.renderAddPopup(), {
                        id: "app-wishlist-popup_add",
                        class: "app-wishlist-popup_add",
                        cb: (el) => {
                            const rightBtn = $(el).find(".popup_remove-right")
                            rightBtn.click(() => {
                                $(el).find(".close").trigger('click');
                                setTimeout(() => {
                                    sessionStorage.setItem(this.LOCAL_STORAGE_WISHLIST_KEY, this.select_id)
                                    let _params = new URLSearchParams(window.location.search);
                                    _params.set("pendding_wish_list", "1") // cache有效性标志
                                    window.jackeryLoginApp.modalLogin({
                                        return_url: `${location.origin}${location.pathname}?${_params.toString()}`,
                                        register_act: 'Wish-Register',
                                        tag: `Wish-${this.shortname}`
                                    }, {
                                        id: "app-wishlist__login"
                                    })
                                }, 300);

                                // 数据埋码
                                gaProductDetailDataLayer({
                                    "product_spu_name": this.getAttribute("product-title"), //识别页面产品spu标题名称text
                                    "module": "Wishlist", //固定模块命名Wishlist
                                    "options": this.select_variant_title, //主体产品sku文本text
                                    "button_name":  rightBtn?.text()?.trim(), //识别按钮的文本text
                                })
                            })
                        }
                    })
                }
            }

            handleAction() {
                if (this.selected) {
                    this.handleRemove()
                } else {
                    this.handleAdd()
                }
            }

            renderRmovePopup() { // 移除心愿单modal
                return `<div class="app-wishlist-popup_remove-container flex">
                <img src="https://cdn.shopify.com/s/files/1/0970/9262/files/wishlist_expoint.png?v=1691562182" class="popup-icon">

                <div class="popup_remove-title">${pageInfo.strings.product.wishlist_removeDesc}</div>

                <div class="popup_remove-button-group flex">
                  <div class="popup_remove-left z-button-fill-big">${pageInfo.strings.product.wishlist_removeCancel}</div>
                  <div class="popup_remove-right z-button-big">${pageInfo.strings.product.wishlist_removeOk}</div>
                </div>
              </div>`
            }

            renderAddPopup() { // 未登录下添加心愿单modal
                // windowText
                return `<div class="app-wishlist-popup_add flex">
                <div class="popup_add-title">${this.wishListInfo.windowTitle}</div>
                <div class="popup_add_subtitle">${this.wishListInfo.windowText.join("<br>")}</div>
                <div class="popup_remove-right z-button-big">${pageInfo.strings.product.wishlist_quick_login_btn}</div>
              </div>`
            }

            addToWish(flag = false) { // 添加or删除指定变体 心愿单
                this.addLoading()
                updateGoodsWishList({
                    "shopifyGoodsId": this.goodsid,
                    "skuIds": flag ? [this.select_id] : [sessionStorage.getItem(this.LOCAL_STORAGE_WISHLIST_KEY)],
                    "isDel": false
                }).then(res => {
                    pushMessage(pageInfo.strings.product.wishlist_joinToast, "success")
                    this.wishListInfo.userSkuIdWishList.push(this.select_id)
                    this.selectors.heart.classList.add("filled")
                    this.wishListInfo.wishCount = res.data.showCount
                    if (!flag) {
                        sessionStorage.removeItem(this.LOCAL_STORAGE_WISHLIST_KEY)
                        this.selected = true // FIX login add init status
                    }
                    this.variantChange()
                    if (res.data.count > 10000 && this.querySelector(".onekplus")) {
                        this.querySelector(".onekplus").classList.add("active")
                        setTimeout(() => {
                            this.querySelector(".onekplus").classList.remove("active")
                        }, 1500);
                    }

                    // wishCount
                }).catch(res => {
                    if (res.code == 71006) {
                        pushMessage(pageInfo.strings.product.wishlist_disabledJoinDesc, "warning");
                    } else {
                        pushMessage("Woops! Something wrong! Please try leater", "warning");
                    }
                }).finally(() => {
                    this.removeLoading()
                })
            }

            addLoading() { // 开启loading
                this.selectors.container.classList.add("loading")
            }

            removeLoading() { // 移除loading
                this.selectors.container.classList.remove("loading")
            }

            uniqeArray(arr) { // 数组去重
                if (!Array.isArray(arr)) {
                    return []
                }
                return [...new Set(arr)]
            }
        })
    }
}